<template>
  <div class="moo-submit-bar">
    <!-- M961: the waiting-time card at the top of the cart has scrolled away by the
         time the customer reaches this button, so the figure is repeated here.
         Text comes in as props (this file has no $t, like the other components)
         and the row renders nothing when the branch hides the waiting time. -->
    <div v-if="waitingTime" class="moo-submit-bar__waiting">
      <i class="material-icons" style="margin-bottom: 2px;">schedule</i>
      <span>{{ waitingLabel }}</span>
      <strong>{{ waitingTime }}</strong>
    </div>
    <button
      type="button"
      class="moo-submit-bar__btn"
      :disabled="disabled || loading"
      @click="$emit('submit')"
    >
      <span v-if="loading" class="moo-submit-bar__spinner"></span>
      <span v-else>{{ label }}</span>
    </button>
    <div class="moo-submit-bar__powered">Powered by Minty™</div>
  </div>
</template>

<script>
// Ported from advocado SubmitOrderBar (MTH023). Fixed bottom submit/pay bar for MyCart.
export default {
  name: "SubmitOrderBar",
  props: {
    label: { type: String, default: "Submit Order" },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    waitingLabel: { type: String, default: "" },
    waitingTime: { type: String, default: "" },
  },
  emits: ["submit"],
};
</script>

<style scoped>
.moo-submit-bar {
  position: fixed;
  bottom: 0;
  /* Center the SAME way .cart-shell (margin:0 auto) does — using left:0/right:0 +
     auto margins keeps the bar within the scrollbar-excluded content width, so it
     no longer drifts right of the cart column when the page has a scrollbar.
     Horizontal padding matches the bootstrap .container gutter (1.5rem) so the
     button edges line up with the cart items. */
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: 480px;
  padding: 1rem 1.5rem calc(1rem + env(safe-area-inset-bottom, 0px));
  background: rgba(255, 255, 255, 0.9);
  -webkit-backdrop-filter: blur(16px);
  backdrop-filter: blur(16px);
  box-shadow: 0 -10px 40px rgba(25, 28, 30, 0.08);
  z-index: 40;
}

/* Sits above the button, one line, quiet: the label muted and only the value in
   the brand colour so it does not fight the button right below it. */
.moo-submit-bar__waiting {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  margin-bottom: 8px;
  font-size: 0.8rem;
  font-weight: 500;
  color: #524342;
}
/* M961: the cart's fixed --adv-success green, hardcoded here because this
   component is outside .moo-cart-page and so cannot see that token. */
.moo-submit-bar__waiting .material-icons {
  font-size: 15px;
  color: #1f8a4c;
}
.moo-submit-bar__waiting strong {
  font-weight: 700;
  color: #1f8a4c;
}

.moo-submit-bar__btn {
  width: 100%;
  height: 56px;
  border-radius: 999px;
  border: none;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.15) 100%), var(--color);
  color: #ffffff;
  font-weight: 800;
  font-size: 1.05rem;
  letter-spacing: 0.02em;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.15s ease;
}
.moo-submit-bar__btn:active:not(:disabled) {
  transform: scale(0.98);
}
.moo-submit-bar__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.moo-submit-bar__powered {
  margin-top: 6px;
  text-align: center;
  font-size: 11px;
  color: #857372;
}

.moo-submit-bar__spinner {
  display: inline-block;
  width: 22px;
  height: 22px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: moo-submit-spin 0.8s linear infinite;
  vertical-align: middle;
}
@keyframes moo-submit-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
